import { t } from "i18next";
import { Chip } from "@material-tailwind/react";
import { statusColors } from "../../../theme/statusPalette";

interface PayerStatusBadgeProps {
  badPayer: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
  iconOnly?: boolean;
}

/**
 * Badge coloré pour afficher le statut de paiement d'un client (Good/Bad Payer)
 * @param badPayer - Indique si c'est un mauvais payeur
 * @param size - Taille du badge
 * @param className - Classes CSS additionnelles
 */
export default function PayerStatusBadge({ 
  badPayer,
  size = "sm",
  className = "",
  iconOnly = false
}: PayerStatusBadgeProps) {
  const style = badPayer
    ? {
        bg: statusColors.red[100],
        dot: statusColors.red[500],
        text: statusColors.red[800],
      }
    : {
        bg: statusColors["pastel-green"][100],
        dot: statusColors["pastel-green"][500],
        text: statusColors["pastel-green"][800],
      };

  const label = badPayer ? t("common:badPayer") : "Good Payer";

  return (
    <Chip
      variant="filled"
      size={size}
      value={
        <div className={`flex items-center justify-center ${iconOnly ? "" : "gap-2"}`}>
          <span 
            className="rounded-full shrink-0" 
            style={{
              width: "8px",
              height: "8px",
              backgroundColor: style.dot,
            }}
          ></span>
          {!iconOnly && <span style={{ color: style.text }}>{label}</span>}
        </div>
      }
      style={{ backgroundColor: style.bg }}
      className={`w-fit h-fit rounded-full capitalize font-normal ${iconOnly ? "p-1.5" : "py-1 text-xs"} ${className}`}
    />
  );
}
